import { makeStyles, tokens } from "@fluentui/react-components";
import { ellipsisMultiline } from "@/common/style/commonStyle";

export const useStyles = makeStyles({
	cardContainer: {
		backgroundColor: tokens.colorNeutralForeground2,
		minHeight: "180px",
		width: "308px",
		position: "fixed",
		zIndex: 999999,
		right: "12px",
		bottom: "232px",
		borderTopLeftRadius: tokens.borderRadiusLarge,
		borderTopRightRadius: tokens.borderRadiusLarge,
	},

	// 308px mirrors the width of the Teams incoming-call toast, so the card
	// reads as an extension of it. The isNextToInternalToaster mode keeps the
	// base 308px width to stay aligned with InteractionActionCard below it.
	containerVoice: {
		right: "10px",
		bottom: "340px",
		width: "308px",
		borderBottomLeftRadius: tokens.borderRadiusLarge,
		borderBottomRightRadius: tokens.borderRadiusLarge,
	},

	// Teams desktop shows the native call toast outside the app window,
	// so there is nothing to align with — dock the card to the corner.
	containerVoiceDesktop: {
		right: "10px",
		bottom: "10px",
		width: "308px",
		borderBottomLeftRadius: tokens.borderRadiusLarge,
		borderBottomRightRadius: tokens.borderRadiusLarge,
	},

	// When the Teams desktop window is anchored to the screen's bottom-right
	// corner (maximized or right-snapped), the native call toast overlays the
	// app just above the taskbar; reserve its footprint and stack the card on
	// top of it, mirroring the web layout. Offsets are empirical for the new
	// Teams client at 100% zoom / default OS scaling.
	containerVoiceDesktopAnchored: {
		right: "10px",
		bottom: "339px",
		width: "360px",
		borderBottomLeftRadius: tokens.borderRadiusLarge,
		borderBottomRightRadius: tokens.borderRadiusLarge,
	},

	innerContainer: {
		margin: "16px 32px",
	},

	transferAgentName: {
		margin: "16px 32px 0px 32px",
	},

	whiteText: {
		color: tokens.colorNeutralBackground1,
	},

	grayText: {
		color: tokens.colorNeutralStroke1Hover,
	},

	details: {
		display: "block",
		height: "20px",
	},

	text: {
		padding: "16px",
	},

	footer: {
		marginTop: "auto",
	},

	bold: {
		fontWeight: tokens.fontWeightBold,
	},

	offeringVariableText: {
		width: "100%",
		textAlign: "center",
		...ellipsisMultiline(3),
	},

	offeringVariableTooltip: {
		width: "96%",
	},

	contentToolTip: {
		margin: "8px",
		textAlign: "start",
		">p": {
			margin: 0,
			textWrap: "wrap",
		},
	},

	offeringVariableTextContainer: {
		width: "100%",
	},

	offeringAiIndicator: {
		alignSelf: "center",
		marginTop: "4px",
		marginBottom: "4px",
	},
});
